import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

function detectScrollMoreForElement(card) {
    const scrollableContent = card.querySelector('.popup-content');	
    const proseContent = scrollableContent?.querySelector('.popup-content--inner');
    
    if (!scrollableContent || !proseContent) return;
    
    // Avoid double initialization
    if (scrollableContent.querySelector('.scroll-more-label')) return;

    // Check if content is scrollable
    const isScrollable = scrollableContent.scrollHeight > scrollableContent.clientHeight;

    if ( isScrollable ) {
		console.log('Scrollable content detected');
        // Create "read more" label
        const readMoreLabel = document.createElement('div');
        readMoreLabel.className = 'scroll-more-label absolute -bottom-1 left-0 right-0 bg-gradient-to-t from-white to-transparent pt-120 pointer-events-none';
        
        // Make parent relative for absolute positioning
        scrollableContent.style.position = 'relative';
        scrollableContent.appendChild(readMoreLabel);
        
        // Handle scroll events
        scrollableContent.addEventListener('scroll', () => {
            const { scrollTop } = scrollableContent;
            const isAtTop = scrollTop === 0;
            
            if ( isAtTop ) {
				gsap.to( readMoreLabel, { autoAlpha: 1, duration: 0.3 } );
            } else {
				gsap.to( readMoreLabel, { autoAlpha: 0, duration: 0.3 } );
            }
        });
    } else {
		console.log('Content is not scrollable');
	}
}

function regularPopup() {
	const selector = '[data-name="popup"]';

	if ( ! document.querySelector( selector ) ) return;

	Fancybox.bind(selector, {
		mainClass: 'fancybox-regular-popup',

		Carousel: {
			friction: 0.8,
			preload: 2,
			infinite: true,
			Toolbar: false, 
			Thumbs: false,  
		},

		on: {
			"init": () => {
				ScrollTrigger.normalizeScroll(false); 
			},
			"destroy": () => {
				ScrollTrigger.normalizeScroll(true);
			},
			"reveal": (fancybox, slide) => {
				const currentPopup = slide.el ? slide.el.querySelector('[data-name="popup-with-scroll-text"]') : null;

				if (currentPopup) {
					detectScrollMoreForElement(currentPopup);
				}
			},
		}
	});
}

function searchPopup() {
	const selector = '[data-name="search-popup"]';
	const trigger = document.querySelector(selector);
	
	if ( ! trigger ) return;

	Fancybox.bind(selector, {
		mainClass: 'fancybox-search-popup',
		autoFocus: false,
		trapFocus: false,
	});

	// Focus the search input when popup opens
	trigger.addEventListener('click', () => {
		// Wait for popup animation to start
		setTimeout(() => {
			const searchInput = document.querySelector('#search-popup input[name="s"]');
			if (searchInput) {
				searchInput.focus();
			}
		}, 200);
	});
}

function videoPopup() {
	const selector = '[data-name="video-popup"]';

	if ( ! document.querySelector( selector ) ) return;

	Fancybox.bind(selector, {
		mainClass: 'fancybox-video-popup',
	});
}

function popups(){
	regularPopup()
	searchPopup()
	videoPopup()
}

export default popups;
